import { Table } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';

import { MenuSelect } from '../../menu-select';
import { TableMenuButton, TableMenuList } from '../shared/table-menu';

export function ColumnFilter<TData>({
  table,
  columnId,
}: {
  table: Table<TData>;
  columnId: string;
}) {
  const { t } = useTranslation('ui');
  const column = table.getColumn(columnId);
  if (!column) {
    return null;
  }

  const filterName = column.columnDef.meta?.name;
  const filterValue = column.getFilterValue();
  const { DisplayFilter, EditFilter } = column.columnDef.meta?.filter || {};

  return (
    <MenuSelect autoSelect={false} defaultIsOpen={filterValue === null}>
      <TableMenuButton
        maxW="sm"
        onRemoveClick={() => {
          column.setFilterValue(undefined);
        }}
        removeLabel={`${t('table.filter.remove')} ${filterName}`}
      >
        {filterName}: {DisplayFilter && <DisplayFilter table={table} column={column} />}
      </TableMenuButton>
      <TableMenuList>{EditFilter && <EditFilter table={table} column={column} />}</TableMenuList>
    </MenuSelect>
  );
}
